import {createRenderer} from "./render";
import Server from "../server";
import {transformRectangle} from "../misc/linear_algebra";
import {HandwrittenWord} from "../bo/handwritten_word";
import {emojis} from "./emojis";

const CONTINUE_WRITING = "continuewriting";
export const CARD_TRANSLATE_CLASS = "card-translate";


var erase = (canvas: any) => {
    const continueWriting = canvas.dataset[CONTINUE_WRITING];
    continueWriting && window.cancelAnimationFrame(continueWriting);
    for (; canvas.lastChild;) canvas.removeChild(canvas.lastChild);
};

const server = Server.instance();

function newG(x: number, y: number, parent?: SVGElement) {
    const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
    g.setAttribute("transform", `translate(${x}, ${y})`);
    if (parent) {
        parent.appendChild(g);
    }
    return g;
}

function extractSVGRect(canvas: SVGSVGElement) {
    const vouter = canvas.getBoundingClientRect();
    const t = canvas.getScreenCTM() as DOMMatrix;
    const vinner = transformRectangle(vouter, t);
    return vinner;
}

type HandwrittenLine = HandwrittenWord[];

function tokeniseOLD(text: string) : HandwrittenLine[] {

    const out : HandwrittenLine[] = [];

    var w = "";
    var i = 0;

    const lines = text.trim().split(/\n+/).map(t => t.trim().replace(/\s+/g, " "));

    const salts : { [key: string]: number } = {};
    for (const line of lines) {
        const l : HandwrittenLine = [];
        const words = line.split(/ /);
        for (const word of words) {
            const salt = salts[word] = (salts[word] === undefined ? -1 : salts[word]) + 1;
            l.push({
                word: word,
                salt: salt
            });
        }
        if (l.length > 0) {
            out.push(l);
        }
    }

    return out;
}

function tokenise(text: string) : HandwrittenLine[] {

    text = text.replace(/[`’’‘]/g, "'");

    text = text.replace(/<3/g, "❤️");
    text = text.replace(/:\)/g, "😀");

    const out : HandwrittenLine[] = [];

    var w = "";
    var i = 0;

    const lines = text.trim().split(/\n/).map(t => t.trim().replace(/\s+/g, " "));

    const salts : { [key: string]: number } = {};
    for (const line of lines) {
        const l : HandwrittenLine = [];

        let text = line;

        if (text.length == 0) {
            // blank line
            out.push([]);
            continue;
        }

        //🥰😍💘💝💖💗💓💞💕💟❣️💔❤️‍🔥❤️‍🩹❤️🩷🧡💛💚💙🩵💜🤎🖤🩶🤍
        //text = text.replace(/[🥰😍💘💝💖💗💓💞💕💟❣️💔❤️‍🔥❤️‍🩹❤️🩷🧡💛💚💙🩵💜🤎🖤🩶🤍]/g, "❤️");
        text = text.replace(/🖤/g, "❤️");
        text = text.replace(/—/g, "-");

        while (text.length > 0) {
            const m = text.match(/^((\s+)|(['!]|❤️[\u{FE0E}\u{FE0F}]?)|([XOox]+\b)|([^\s'!❤️]+))(.*)/u);

            if (! m) {
                break;
            }
            let word = m[1];
            const whitespace = m[2];
            let xo = m[4];
            text = m[6];

            if (word === undefined || word.length == 0) {
                continue; // can happen with emojis and variant selectors...
            }

            if (xo) {
                xo = xo.toLowerCase();
                xo = xo.replace(/xo/g, "x o");
                xo = xo.replace(/ox/g, "o x");
                const xos = xo.split("");
                for (const c of xos) {
                    const w = {
                        word: c,
                        salt: 0,
                    }
                    l.push(w);
                }
            } else {
                const salt = whitespace ? 0 : (salts[word] = (salts[word] === undefined ? -1 : salts[word]) + 1);

                // Characters that can't be rendered - replace
                word = word.replace(/~/, "-");

                const w = {
                    word: word,
                    salt: salt,
                }
                l.push(w);
            }

        }

        if (l.length > 0) {
            out.push(l);
        }
    }

    console.log("XXXXXXX", out);

    return out;
}

const write = async (canvas: SVGSVGElement, topOffset: any, text: string, opts: any) => {

    const SPACE_WIDTH = 10;
    const LINE_HEIGHT = 40;

    erase(canvas);

    var g0 = document.createElementNS("http://www.w3.org/2000/svg", "g");
    g0.classList.add(CARD_TRANSLATE_CLASS)
    if (opts.transform) {
        g0.setAttribute("transform", opts.transform);
    }
    canvas.appendChild(g0);

    const vinner = extractSVGRect(canvas);

    const verticalMargin = 20;
    const sideMargin = 20;

    const svgWidth = vinner.width;
    const svgHeight = vinner.height;

    const rightMargin = 40;

    const g1 = newG(sideMargin, verticalMargin, g0);

    const lines = tokenise(text);

    const words: HandwrittenWord[] = [];
    for (const line of lines) {
        for (const w of line) {
            words.push(w);
        }
    }
    const styleIdx = opts.styleIdx;

    if (true) {
        // For generating snippets
        // @ts-ignore
        window.globalStyleIdx = styleIdx;
    }

    const data = await server.handwritingWords(styleIdx, words);

    function acceptPeny(peny: number, scale: number) {
        const z = peny + verticalMargin + LINE_HEIGHT < svgHeight;
        return z;
    }

    let scale = 1;
    let done = false;

    while (scale > 0.1 && ! done) {
        const peny = layout(scale);
        done = acceptPeny(peny, scale);
        scale = scale * 0.9;
    }

    function layout(scale: number) {

        for (; g1.lastChild;) g1.removeChild(g1.lastChild);

        const centerer = document.createElementNS("http://www.w3.org/2000/svg", "g");
        g1.appendChild(centerer);

        const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
        g.setAttribute("transform", `scale(${scale})`);
        centerer.appendChild(g);

        let penx = 0;
        let peny = 0;

        const newline = (gws?: SVGGElement[]) => {
            // wrap
            penx = 0;
            peny += LINE_HEIGHT;

            function xy(gw: SVGGElement) {
                const transformList = gw.transform.baseVal;
                const m = transformList.getItem(0).matrix;
                return {
                    x: m.e,
                    y: m.f
                };
            }

            if (gws && gws.length > 0) {

                const xy0 = xy(gws[0]);

                let gw: SVGGElement | undefined = undefined;
                for (gw of gws) {
                    const xy1 = xy(gw);
                    gw.setAttribute("transform", `translate(${xy1.x - xy0.x + penx}, ${peny})`);
                }

                if (gw) {
                    const box = gw.getBBox();
                    const xy2 = xy(gw);
                    penx += xy2.x + box.width ;
                   // penx += xy2.x + box.width + SPACE_WIDTH;
                }

            }
        };

        const sinceWhitespace : SVGGElement[] = [];

        let i = -1;
        for (const line of lines) {

            if (penx > 0 || i >= 0) {
                sinceWhitespace.length = 0;
                newline();
            }

            for (const word of line) {

                i ++;
                const w = data[i];

                if (! w.word || w.word.trim().length == 0) {
                    // whitespace
                    penx += SPACE_WIDTH;
                    sinceWhitespace.length = 0;
                    continue;
                }

                const padding = {
                    "'": SPACE_WIDTH / 3,
                    "!": SPACE_WIDTH / 3,
                    "❤️": SPACE_WIDTH,
                }

                // @ts-ignore
                const p : number | undefined = padding[w.word];
                if (p) {
                    penx += p;
                }

                // @ts-ignore
                let d = w.rendered;
                if (! d) {
                    continue; // should not happen
                }

                const gw = newG(penx, peny, g);

                if (w.word.codePointAt(0) == "❤️".codePointAt(0)) {
                    const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
                    gw.appendChild(g);
                    g.outerHTML = emojis["heart"];
                } else if (w.word.codePointAt(0) == "😀".codePointAt(0)) {
                    const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
                    gw.appendChild(g);
                    g.outerHTML = emojis["smiley"];
                } else {
                    const renderer = createRenderer(gw);
                    renderer(d, 1);
                }

                sinceWhitespace.push(gw);

                const box = gw.getBBox();
                penx += box.width;

                if (w.word === "'") {
                    penx += SPACE_WIDTH / 3;
                }

                if (penx * scale > svgWidth - rightMargin) {
                    newline(sinceWhitespace);
                    sinceWhitespace.length = 0;
                }
            }
        }

        const box_g = g.getBBox();

        const h_adj = Math.max(0, svgWidth - 2 * sideMargin - box_g.width) / 2;
        const v_adj = Math.max(0, svgHeight - 2 * verticalMargin - box_g.height) / 2;

        centerer.setAttribute("transform", `translate(${h_adj}, ${v_adj})`);

        return peny * scale;
    }

};

export async function writeToCanvas(canvas: SVGSVGElement, text: string, opts: any) {
    return write(canvas, 40, text, opts);
}



/*
💙
💛
🖤
🤍
🥰
🩷
 */
